











import { Component, Watch, PropSync } from 'vue-property-decorator';
import AddressForm from '@/components/Form/AddressForm.vue';
import AdditionalInformationForm from '@/components/Form/AdditionalInformationForm.vue';
import FormSwitch from '@/components/Form/InputComponents/FormSwitch.vue';
import { NamedOption } from '@/util/NamedOption';
import Validatable from '@/components/Validatable.vue';
import { Member } from '@/util/Member';
import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormInput from '@/components/Form/InputComponents/FormInput.vue';
import BirthdayForm from '@/components/Form/BirthdayForm.vue';

@Component({
  components: {
    FormInput,
    FormGroup,
    FormSwitch,
    AddressForm,
    AdditionalInformationForm,
    BirthdayForm
  }
})
export default class AdditionalInformation extends Validatable {
  @PropSync('member', { required: true }) memberSync!: Member;

  isClosed = false;

  switchOption?: NamedOption;

  @Watch('isClosed')
  CacheIsClosed(value: boolean) {
    const memberItemCacheString = localStorage[`member-${this.memberSync.id}`];
    let memberItemCache;

    if (!memberItemCacheString) {
      memberItemCache = {};
    } else {
      memberItemCache = JSON.parse(memberItemCacheString);
    }

    memberItemCache.additionalInformationClosed = value;

    localStorage[`member-${this.memberSync.id}`] = JSON.stringify(memberItemCache);
  }

  beforeCreate(): void {
    this.switchOption = new NamedOption(
      this.$t('open-address').toString(),
      false,
      'open-address'
    );
  }

  created(): void {
    const memberItemCacheString = localStorage[`member-${this.memberSync.id}`];

    if (memberItemCacheString) {
      const memberItemCache = JSON.parse(memberItemCacheString);

      this.isClosed = memberItemCache.additionalInformationClosed;
    }
  }

  validate(silent = false) {
    if (!this.isClosed) {
      const superClass = (this.constructor as any).super;

      const methods = superClass.options.methods;

      return methods.validate.call(this, silent);
    }
    return true;
  }
}
